import { ApiProperty } from "@nestjs/swagger";

export class FileUploadMainDto {
    @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
    files: Express.Multer.File[];
}
